const BRACKETED_IPV6 = /^\[(.+)\](?::\d+)?$/
const IPV4_WITH_PORT = /^(\d{1,3}(?:\.\d{1,3}){3}):\d+$/

export const normalizeForwardedClientIp = (raw: string): string => {
    const trimmed = raw.trim()
    if (!trimmed) {
        return ''
    }
    const bracketed = BRACKETED_IPV6.exec(trimmed)
    if (bracketed) {
        return bracketed[1]
    }
    const ipv4WithPort = IPV4_WITH_PORT.exec(trimmed)
    if (ipv4WithPort) {
        return ipv4WithPort[1]
    }
    return trimmed
}
